import React from 'react';
import {
  Box,
  TextField,
  Grid
} from '@mui/material';
import type { Person } from '../../../../types';

interface PersonalDetailsFormProps {
  data: Partial<Person>;
  errors: Record<string, string>;
  onChange: (field: string, value: any) => void;
  disabled?: boolean;
}

/**
 * PersonalDetailsForm - Edit personal details
 *
 * Fields:
 * - Interests (comma-separated)
 * - Personality (multiline)
 * - Physical Description (multiline)
 */
export const PersonalDetailsForm: React.FC<PersonalDetailsFormProps> = ({
  data,
  errors,
  onChange,
  disabled = false
}) => {
  return (
    <Box sx={{ pt: 2 }}>
      <Grid container spacing={3}>
        {/* Interests */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="Interests"
            value={
              Array.isArray(data.interests)
                ? data.interests.join(', ')
                : data.interests || ''
            }
            onChange={(e) => onChange('interests', e.target.value.split(',').map(i => i.trim()).filter(Boolean))}
            error={!!errors.interests}
            helperText={errors.interests || 'Separate multiple interests with commas'}
            disabled={disabled}
          />
        </Grid>

        {/* Personality */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Personality"
            value={data.personality || ''}
            onChange={(e) => onChange('personality', e.target.value)}
            error={!!errors.personality}
            helperText={errors.personality || 'Describe their personality traits and characteristics'}
            disabled={disabled}
          />
        </Grid>

        {/* Physical Description */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Physical Description"
            value={data.physicalDescription || ''}
            onChange={(e) => onChange('physicalDescription', e.target.value)}
            error={!!errors.physicalDescription}
            helperText={errors.physicalDescription || 'Describe their physical appearance'}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
